import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 6,
  class: "dev-mode-video--promoted"
}
const _hoisted_2 = ["alt", "src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ViewerOverlayCallView = _resolveComponent("ViewerOverlayCallView")
  const _component_EmptyCallView = _resolveComponent("EmptyCallView")
  const _component_VideoVue = _resolveComponent("VideoVue")
  const _component_LocalVideo = _resolveComponent("LocalVideo")
  const _component_ScreenShare = _resolveComponent("ScreenShare")
  const _component_PresenterOverlay = _resolveComponent("PresenterOverlay")
  const _component_VideoBottomBar = _resolveComponent("VideoBottomBar")
  const _component_VideosGrid = _resolveComponent("VideosGrid")
  const _component_ReactionToaster = _resolveComponent("ReactionToaster")
  const _component_LiveTranscriptionRenderer = _resolveComponent("LiveTranscriptionRenderer")
  const _component_BottomBar = _resolveComponent("BottomBar")

  return (_openBlock(), _createElementBlock("div", {
    id: "call-container",
    class: _normalizeClass($options.callContainerClass)
  }, [
    ($options.isViewerOverlay)
      ? (_openBlock(), _createBlock(_component_ViewerOverlayCallView, {
          key: 0,
          token: $props.token,
          model: $options.promotedParticipantModel,
          "shared-data": $options.promotedParticipantModel && $data.sharedDatas[$options.promotedParticipantModel.attributes.peerId],
          screens: $data.screens,
          "local-shared-data": $data.localSharedData
        }, null, 8, ["token", "model", "shared-data", "screens", "local-shared-data"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($options.showEmptyCallView)
            ? (_openBlock(), _createBlock(_component_EmptyCallView, {
                key: 0,
                "is-sidebar": $props.isSidebar
              }, null, 8, ["is-sidebar"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: "videos",
            class: _normalizeClass({ 'is-sidebar': $props.isSidebar })
          }, [
            ($setup.devMode ? !$options.isGrid : (!$options.isGrid || !$options.callParticipantModels.length))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["video__promoted", { 'full-page': $options.showFullPage }])
                }, [
                  ($options.showSelectedVideo && $options.selectedCallParticipantModel)
                    ? (_openBlock(), _createBlock(_component_VideoVue, {
                        key: `promoted-${$options.selectedVideoPeerId}`,
                        token: $props.token,
                        model: $options.selectedCallParticipantModel,
                        "shared-data": $data.sharedDatas[$options.selectedVideoPeerId],
                        "show-talking-highlight": false,
                        "is-one-to-one": $options.isOneToOne,
                        "is-grid": "",
                        "is-big": "",
                        "fit-video": ""
                      }, null, 8, ["token", "model", "shared-data", "is-one-to-one"]))
                    : ($options.showLocalVideo)
                      ? (_openBlock(), _createBlock(_component_LocalVideo, {
                          key: 1,
                          ref: "localVideo",
                          token: $props.token,
                          "local-media-model": $setup.localMediaModel,
                          "local-call-participant-model": $setup.localCallParticipantModel,
                          "is-stripe": false,
                          "show-controls": false,
                          "is-sidebar": false,
                          "is-big": "",
                          "fit-video": ""
                        }, null, 8, ["token", "local-media-model", "local-call-participant-model"]))
                      : ($options.showLocalScreen)
                        ? (_openBlock(), _createBlock(_component_ScreenShare, {
                            key: "screen-local",
                            token: $props.token,
                            "local-media-model": $setup.localMediaModel,
                            "shared-data": $data.localSharedData,
                            "is-big": ""
                          }, null, 8, ["token", "local-media-model", "shared-data"]))
                        : (($options.showRemoteScreen || $options.showSelectedScreen) && $options.shownRemoteScreenCallParticipantModel)
                          ? (_openBlock(), _createBlock(_component_ScreenShare, {
                              key: `screen-${$options.shownRemoteScreenPeerId}`,
                              token: $props.token,
                              "call-participant-model": $options.shownRemoteScreenCallParticipantModel,
                              "shared-data": $data.sharedDatas[$options.shownRemoteScreenPeerId],
                              "is-big": ""
                            }, null, 8, ["token", "call-participant-model", "shared-data"]))
                          : ($options.promotedParticipantModel)
                            ? (_openBlock(), _createBlock(_component_VideoVue, {
                                key: `autopilot-${$options.promotedParticipantModel.attributes.peerId}`,
                                token: $props.token,
                                model: $options.promotedParticipantModel,
                                "shared-data": $data.sharedDatas[$options.promotedParticipantModel.attributes.peerId],
                                "show-talking-highlight": false,
                                "is-grid": "",
                                "fit-video": "",
                                "is-big": "",
                                "is-one-to-one": $options.isOneToOne,
                                "is-sidebar": $props.isSidebar,
                                onForcePromoteVideo: _cache[0] || (_cache[0] = $event => ($data.forcePromotedModel = $event))
                              }, null, 8, ["token", "model", "shared-data", "is-one-to-one", "is-sidebar"]))
                            : _createCommentVNode("", true),
                  ($options.shouldShowPresenterOverlay)
                    ? (_openBlock(), _createBlock(_component_PresenterOverlay, {
                        key: 5,
                        token: $props.token,
                        model: $options.presenterModel,
                        "shared-data": $options.presenterSharedData,
                        "is-local-presenter": $options.showLocalScreen,
                        "local-media-model": $setup.localMediaModel,
                        "is-collapsed": !$data.showPresenterOverlay,
                        onClick: $options.toggleShowPresenterOverlay
                      }, null, 8, ["token", "model", "shared-data", "is-local-presenter", "local-media-model", "is-collapsed", "onClick"]))
                    : ($setup.devMode && !$options.isGrid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createElementVNode("img", {
                            alt: $options.placeholderName(6),
                            src: $options.placeholderImage(6)
                          }, null, 8, _hoisted_2),
                          _createVNode(_component_VideoBottomBar, {
                            "has-shadow": false,
                            model: $options.placeholderModel(6),
                            "shared-data": $options.placeholderSharedData(6),
                            token: $props.token,
                            "participant-name": $options.placeholderName(6),
                            "is-big": ""
                          }, null, 8, ["model", "shared-data", "token", "participant-name"])
                        ]))
                      : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (!$props.isSidebar)
              ? (_openBlock(), _createBlock(_component_VideosGrid, _mergeProps({
                  key: 1,
                  "is-stripe": $setup.devMode ? !$options.isGrid : (!$options.isGrid || !$options.callParticipantModels.length),
                  "is-recording": $props.isRecording,
                  token: $props.token,
                  "has-pagination": true,
                  "is-overlap": $options.showFullPage,
                  "call-participant-models": $options.callParticipantModels,
                  screens: $data.screens,
                  "local-media-model": $setup.localMediaModel,
                  "local-call-participant-model": $setup.localCallParticipantModel,
                  "shared-datas": $data.sharedDatas
                }, _ctx.$attrs, {
                  onSelectVideo: $options.handleSelectVideo,
                  onClickLocalVideo: $options.handleClickLocalVideo
                }), null, 16, ["is-stripe", "is-recording", "token", "is-overlap", "call-participant-models", "screens", "local-media-model", "local-call-participant-model", "shared-datas", "onSelectVideo", "onClickLocalVideo"]))
              : _createCommentVNode("", true),
            ($options.supportedReactions?.length)
              ? (_openBlock(), _createBlock(_component_ReactionToaster, {
                  key: 2,
                  token: $props.token,
                  "supported-reactions": $options.supportedReactions,
                  "call-participant-models": $options.callParticipantModels
                }, null, 8, ["token", "supported-reactions", "call-participant-models"]))
              : _createCommentVNode("", true),
            ($options.isLiveTranscriptionEnabled)
              ? (_openBlock(), _createBlock(_component_LiveTranscriptionRenderer, {
                  key: 3,
                  token: $props.token,
                  "call-participant-models": $options.callParticipantModels
                }, null, 8, ["token", "call-participant-models"]))
              : _createCommentVNode("", true),
            ($props.isSidebar && !$options.showLocalVideo)
              ? (_openBlock(), _createBlock(_component_LocalVideo, {
                  key: 4,
                  ref: "localVideo",
                  class: _normalizeClass(["local-video", { 'local-video--sidebar': $props.isSidebar }]),
                  "show-controls": false,
                  "fit-video": true,
                  "is-stripe": true,
                  token: $props.token,
                  "local-media-model": $setup.localMediaModel,
                  "local-call-participant-model": $setup.localCallParticipantModel,
                  "is-sidebar": $props.isSidebar,
                  onClickVideo: $options.handleClickLocalVideo
                }, null, 8, ["class", "token", "local-media-model", "local-call-participant-model", "is-sidebar", "onClickVideo"]))
              : _createCommentVNode("", true)
          ], 2),
          (!$props.isRecording)
            ? (_openBlock(), _createBlock(_component_BottomBar, {
                key: 1,
                "is-sidebar": $props.isSidebar
              }, null, 8, ["is-sidebar"]))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}